export const formatDate = (format: string, inputDateStr: string) => {
  const inputDate = new Date(inputDateStr)

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
    //hour24: true
  }
  return inputDate.toLocaleString(format, options)
}
